import * as React from 'react';
import { connect, useDispatch } from 'react-redux';
import * as microsoftTeams from "@microsoft/teams-js";
import { useLocation } from 'react-router';
import queryString from 'query-string';
import { setToken } from '../../store/Login/actions';

const Success = () => {
    const dispatch = useDispatch();
    const location = useLocation();
    React.useEffect(() => {
        microsoftTeams.initialize();
        const data = queryString.parse(location.search);
        dispatch(setToken(data));
        const token = data['access_token'] as string;
        if (token == null || token == undefined || token == '') {
            microsoftTeams.authentication.notifyFailure();
        }
        else {
            microsoftTeams.authentication.notifySuccess(token);
        }
        
    });
    return (
        <div>
            Anauthorized Access
        </div>
    )
};

export default connect()(Success);
